(function () {
  'use strict';

  angular
    .module('app')
    .service('TransportationContentModalService', TransportationContentModalService);

  TransportationContentModalService.$inject = ['ModalService'];

  function TransportationContentModalService(ModalService) {
    var service = {
      openTransportationContentsModal: openTransportationContentsModal,
      openTransportationContentTranslationsModal: openTransportationContentTranslationsModal,
    };

    return service;

    ////////////////

    // --------------------------- openTransportationContentsModal -------------------------

    function openTransportationContentsModal(transportation) {
      ModalService.showModal({
        templateUrl: './app/ajs/transportation-contents/modals/transportation-contents-modal.html',
        controller: TransportationContentsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          transportation: transportation,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      TransportationContentsModalCtrl.$inject = [
        '$element',
        'UtilService',
        'AbilityService',
        '$location',
        'TransportationService',
        'TransportationContentService',
        'SessionService',
        'transportation',
      ];
    }

    function TransportationContentsModalCtrl(
      $element,
      UtilService,
      AbilityService,
      $location,
      TransportationService,
      TransportationContentService,
      SessionService,
      transportation
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canShow: AbilityService.can('show_transportation_accountadmin'),
        canCreate: AbilityService.can('create_transportation_accountadmin'),
        canUpdate: AbilityService.can('update_transportation_accountadmin'),
        canDestroy: AbilityService.can('destroy_transportation_accountadmin'),
      };

      vm.transportation = transportation;
      vm.modalTitle = transportation.name;

      // Methods
      vm.showContent = showContent;
      vm.deleteContent = deleteContent;
      vm.changeContentStatus = changeContentStatus;
      vm.changeContentPublished = changeContentPublished;
      vm.addContent = addContent;

      var companyWebsites = SessionService.getSelectedAccountCompany().websites;

      // Initializers
      setTransportationContents();
      setAvailableWebsites();

      function setTransportationContents() {
        vm.usedCompanyWebsites = [];

        var transportationContents = [];

        if (vm.transportation.transportation_contents) {
          vm.transportation.transportation_contents.forEach(function (content) {
            for (var i = 0; i < companyWebsites.length; i++) {
              var companyWebsite = companyWebsites[i];
              if (content && companyWebsite.id === content.website_id) {
                content.website_name = companyWebsite.name;
                vm.usedCompanyWebsites.push(companyWebsite);
                break;
              }
            }

            transportationContents.push(content);
          });
        }

        vm.transportation.contents = transportationContents;
      }

      function setAvailableWebsites() {
        vm.availableCompanyWebsites = [];

        for (var i = 0; i < companyWebsites.length; i++) {
          var companyWebsite = companyWebsites[i];
          var found = false;
          for (var j = 0; j < vm.usedCompanyWebsites.length; j++) {
            var usedCompanyWebsite = vm.usedCompanyWebsites[j];
            if (companyWebsite.id === usedCompanyWebsite.id) {
              found = true;
              break;
            }
          }

          if (!found) {
            vm.availableCompanyWebsites.push(companyWebsite);
          }
        }
      }

      function getTransportation() {
        TransportationService.getTransportation(transportation.id).then(function (data) {
          vm.transportation = data;
          setTransportationContents();
          setAvailableWebsites();
        });
      }

      function showContent(content) {
        if (!vm.permissions.canShow) {
          return;
        }

        setTimeout(function () {
          // Delay x sec
          $location
            .path(`/transportation_contents/${content.id}`)
            .search({ WSID: content.website_id });
        }, 100);

        $element.modal('hide'); // bootstrap fade
      }

      function deleteContent(content) {
        TransportationContentService.deleteTransportationContent(content, getTransportation);
      }

      function changeContentStatus(content) {
        TransportationContentService.changeTransportationContentStatus(content);
      }

      function changeContentPublished(content) {
        TransportationContentService.changeTransportationContentPublished(content);
      }

      function addContent() {
        if (!vm.permissions.canCreate) {
          return;
        }

        setTimeout(function () {
          // Delay x sec
          $location
            .path(`/transportation_contents/new`)
            .search({ WSID: vm.website.id, transportationId: vm.transportation.id });
        }, 100);

        $element.modal('hide'); // bootstrap fade
      }
    }

    // --------------------------- openTransportationContentTranslationsModal -------------------------

    function openTransportationContentTranslationsModal(itemId, websiteName, additionalLanguages) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/transportation-contents/modals/transportation-content-detail-translation.html',
        controller: TransportationContentTranslationsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          itemId: itemId,
          websiteName: websiteName,
          additionalLanguages: additionalLanguages,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      TransportationContentTranslationsModalCtrl.$inject = [
        'UtilService',
        'TransportationContentService',
        'TagService',
        'itemId',
        'websiteName',
        'additionalLanguages',
      ];
    }

    function TransportationContentTranslationsModalCtrl(
      UtilService,
      TransportationContentService,
      TagService,
      itemId,
      websiteName,
      additionalLanguages
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.additionalLanguages = additionalLanguages;

      // Methods
      vm.getContent = getContent;
      vm.updateItem = updateItem;

      vm.tagTransform = tagTransform;
      vm.checkTagOptions = checkTagOptions;

      // Initializers
      getContent(additionalLanguages[0].lang);

      function getContent(language) {
        TransportationContentService.getTransportationContent(itemId, language).then(function (
          data
        ) {
          vm.item = data;

          vm.modalTitle = vm.item.name + ' (' + websiteName + ')';

          vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(vm.item.url_video);

          vm.languageSelected = language;

          getTags(language);
        });
      }

      function updateItem(isFormValid, language) {
        vm.formErrors = false;

        var to = 'translation_form';

        if (!isFormValid) {
          vm.serverErrors = [];

          vm.formErrors = true;
          vm.UtilService.scrollToTop(to);

          return;
        }

        vm.sendingForm = true;
        TransportationContentService.saveTransportationContent(vm.item, language).then(function (
          response
        ) {
          if (response.errors) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);

            vm.formErrors = true;
            vm.UtilService.scrollToTop(to);
          }

          vm.sendingForm = false;
        });
      }

      // ----- TAGS ----- //

      function getTags(lang) {
        TagService.getTags({ skip_check_role: true, by_lang: lang }).then(function (data) {
          vm.tags = data.items;
        });
      }

      function tagTransform(name) {
        return TagService.tagTransform(name, vm.languageSelected);
      }

      function checkTagOptions(tag) {
        vm.tagOptions = TagService.checkTagOptions(tag, vm.tags);
      }
    }
  }
})();
